import { useState } from "react";
import "./index.css";
import profile from "../../../assets/images/Carousel/s1.jpg";
import ReactApexChart from "react-apexcharts";
import TradingViewChart from "../../../components/TradingViewChart";

export const MarketCard = () => {
  return (
    <div className="market-card">
      <h2 className="market-heading">
        Market Overview | <span className="positive">OHO</span>
      </h2>
      <div className="market-data">
        <div className="market-data-row">
          <p className="market-dummy-label">Traders:</p>
          <p className="market-dummy-value">123,456</p>
        </div>
        <div className="market-data-row">
          <p className="market-dummy-label">Volume:</p>
          <p className="market-dummy-value">789.01M</p>
        </div>
        <div className="market-data-row">
          <p className="market-dummy-label">Value:</p>
          <p className="market-dummy-value">$1.23B</p>
        </div>
      </div>
    </div>
  );
};

export const DummyCard = ({
  symbol,
  price,
  change,
  volume,
  color = "GREEN", // or "RED"
}) => {
  const chartOptions = {
    chart: {
      type: "line",
      sparkline: { enabled: true },
    },
    stroke: {
      curve: "smooth",
      width: 2,
      colors: [color === "GREEN" ? "#28a745" : "#dc3545"],
    },
    tooltip: {
      enabled: false,
    },
  };

  const chartSeries = [
    {
      name: "Price",
      data: [price, price, price, price], // or dynamic values if you have them
    },
  ];

  return (
    <div className="info-card">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="sub-info-card">
          <div className="info-card-profile-sec flex-align-start">
            <p className="line-height-normal sub-info-card-head">{symbol}</p>
            <p className="line-height-normal sub-info-card-full-form">
              Vol: {volume}
            </p>
          </div>
        </div>
        <div className="sub-info-card">
          <div className="res-hidden">
            <ReactApexChart
              options={chartOptions}
              series={chartSeries}
              type="line"
              height={40}
              width="100%"
            />
          </div>
          <div className="info-card-btn">
            <button>{price}</button>
            <p style={{ color: color === "GREEN" ? "#28a745" : "#dc3545" }}>
              {change}
            </p>
          </div>
        </div>
      </div>
      <div className="res-show">
        <ReactApexChart
          options={chartOptions}
          series={chartSeries}
          type="line"
          height={40}
          width={"90%"}
        />
      </div>
    </div>
  );
};

export const TabButtons = () => {
  const [activeTab, setActiveTab] = useState("normal");

  return (
    <div className="tab-buttons">
      <button
        className={`tab-btn ${activeTab === "normal" ? "active" : ""}`}
        onClick={() => setActiveTab("normal")}
      >
        Normal
      </button>
      <button
        className={`tab-btn ${activeTab === "percentage" ? "active" : ""}`}
        onClick={() => setActiveTab("percentage")}
      >
        Percentage
      </button>
    </div>
  );
};

export const DummyTrading = () => {
  return (
    <div className="dummy-trading">
      <TradingViewChart />

      <div className="market-grid ">
        <MarketCard />
        <MarketCard />
      </div>
      <div style={{ marginTop: "1rem" }}>
        <p className="market-heading margin-res">Losers</p>
        <div className="market-grid ">
          <DummyCard />
          <DummyCard />
          <DummyCard />
          <DummyCard />
          <DummyCard />
        </div>
      </div>

      <div style={{ marginTop: "1rem" }}>
        <p className="market-heading margin-res">Gainers</p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <TabButtons />
        </div>
        <div className="market-grid">
          <DummyCard />
          <DummyCard />
          <DummyCard />
          <DummyCard />
          <DummyCard />
        </div>
      </div>
    </div>
  );
};
